const appEvents = {
  APP_REDUCER_NPS_TOKEN: 'app/npsToken',
};

export default appEvents;
